document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;

  const container = document.querySelector('.learn-gas-bloating-sticky');
  if (!container) return;

  const links = container.querySelectorAll('a');

  links.forEach(link => {
    const linkUrl = link.href;

    // Exact match OR partial match (you can adjust this)
    if (currentUrl === linkUrl || currentUrl.includes(linkUrl)) {
      link.classList.add('sticky-active-link');
    } else {
      link.classList.remove('sticky-active-link');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;

  const sections = document.querySelectorAll('.icon-tabs-section');

  sections.forEach(section => {
    const items = section.querySelectorAll('.icon-tabs__item');

    items.forEach(item => {
      const onclickAttr = item.getAttribute("onclick");

      if (!onclickAttr) return;

      // Extract URL from onclick="window.location='URL'"
      const match = onclickAttr.match(/window\.location='(.*?)'/);

      if (!match || !match[1]) return;

      const linkUrl = match[1];

      // Match logic (same as your sticky script)
      if (currentUrl === linkUrl || currentUrl.includes(linkUrl)) {
        item.classList.add('icon-tabs__item--active');
      } else {
        item.classList.remove('icon-tabs__item--active');
      }
    });
  });
});

document.querySelectorAll('.cs-blog-post-content h2').forEach((heading) => {
  let text = heading.textContent;

  // find first alphabet character
  let index = text.search(/[a-zA-Z]/);

  if (index !== -1) {
    heading.textContent =
      text.slice(0, index) +
      text.charAt(index).toUpperCase() +
      text.slice(index + 1).toLowerCase();
  }
});

  document.querySelector('.btn-shop-now').addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector('.recharge-subscription-widget');
    
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
